import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { META_ERROR_NOTICE_NAMESPACE } from 'src/utils/metaErrorNotice';

import './UnavailableFile.styles.scss';

/**
 * INT-1506: stands in for a file the lead sent that Meta could not download
 * (131052). The notice below the row explains what happened. It never names
 * the file: for a message carrying an error, WBS forwards only Meta's error
 * text, no attachment, so there is no name to show.
 */
export default function UnavailableFile() {
  const { t } = useTranslation(META_ERROR_NOTICE_NAMESPACE);

  return (
    <div className="UnavailableFile" data-testid="unavailable-file">
      <DocumentTextIcon className="UnavailableFile__Icon" aria-hidden="true" />
      <span className="UnavailableFile__Label">
        {t('file.unavailable', { name: t('file.fallbackName') })}
      </span>
    </div>
  );
}
